import { Component, OnInit, NgZone } from '@angular/core';
import { AddfriendService } from './addfriend.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import * as moment from 'moment';
import{Toast}from '../globals';

declare var $: any;

@Component({
  selector: 'app-addfriend',
  templateUrl: './addfriend.page.html',
  styleUrls: ['./addfriend.page.scss'],
})
export class AddfriendPage implements OnInit {
  ListAllCity: any;
  model: any = {};
  varSelMakan: any = "محدوده";
  FirstName: any = "hi"
  constructor(private addfriend_serv: AddfriendService, private router: Router, private alertController: AlertController, public zone: NgZone) {
    this.ShowCity();
    
  }

  ngOnInit() {
  }

  ShowCity() {

    this.addfriend_serv.ShowCity().subscribe(
      res => {
        this.zone.run(() => {
          this.ListAllCity = res;

        });

        console.log("ListAllCity", this.ListAllCity);

      }, err => {
        console.log(err);
      });
  }


  Save() {
    this.model.UserCreateID = 0;
    this.model.IDRef = 1;
    this.model.IsStatus = false;

    if (this.model.Sex == 'true') {
      this.model.Sex = true;
    } else {
      this.model.Sex = false;
    }
    // this.model.BrithDate=moment(this.model.BrithDate).format('YYYY-MM-DD');
    this.model.FK_CityID = Number(this.model.FK_CityID);


    console.log(this.model);

    this.addfriend_serv.Save(this.model).subscribe(
      res => {

        console.log("res", res)

        if (res == true) {

          Toast.presentToast('success','Information has been successfully registered');
          this.model = {};
        }
        else {
          Toast.presentToast('danger','Information has been successfully registered');
        }

      }, err => {
        console.log(err);
      });

  }




}
